import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ModeSliceState {
  value: "store" | "region" | "alert";
}

const initialState: ModeSliceState = {
  value: "store",
};

export const ModeSliceSlice = createSlice({
  name: "modeSlice",
  initialState,
  reducers: {
    handleModeSlice: (
      state,
      action: PayloadAction<ModeSliceState["value"]>
    ) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { handleModeSlice } = ModeSliceSlice.actions;

export default ModeSliceSlice.reducer;
